export default {
  langName: "Nederlands",
  common: {
    company: "An Eagle Inc company",
    privacy: "Privacy",
    terms: "Gebruiksvoorwaarden",
    support: "Support",
  },
  nav: {
    group: "Eagle Eyes Group",
    realEstate: "Real Estate",
    itManagement: "IT Management",
    digitalServices: "Digital Services",
    backToGroup: "Eagle Eyes Group",
    property: "Property",
    investment: "Investment",
  },
  form: {
    name: "Volledige naam",
    email: "E-mailadres",
    sending: "Verzenden…",
    sent: "Bedankt — je gegevens zijn binnen. We nemen snel contact op.",
    error: "Er ging iets mis. Probeer het opnieuw of mail ons direct.",
  },
  gateway: {
    hero1: "EAGLE",
    hero2: "EYES",
    hero3: "GROUP",
    chapters: [
      { num: "01", name: "Real Estate", sub: "Property · Investment — Tirana", desc: "Huurwoningen die met zorg worden beheerd, en een controleerbare, gedisciplineerde aanpak van residentieel vastgoedbeleggen.", cta: "Naar Real Estate" },
      { num: "02", name: "IT Management", sub: "Consultancy & beheerde diensten", desc: "Senior IT-consultancy voor cloud, identiteit, beveiliging en DevOps — nauwkeurig gescoped, persoonlijk geleverd, duurzaam beheerd.", cta: "Naar IT Management" },
      { num: "03", name: "Digital Services", sub: "Producten die we bouwen & draaien", desc: "Een groeiend portfolio van live web- en mobiele producten in social commerce, marketing en boekingen — in eigen huis ontworpen en beheerd.", cta: "Naar Digital Services" },
    ],
    footerBrand: "Eagle Eyes Group",
  },
  re: {
    forClients: "Voor klanten",
    propertyH: "Property",
    propertyP: "Huurwoningen in het centrum van Tirana, gevonden en beheerd met zorg. Voor mensen die een plek willen om te wonen, geen transactie.",
    propertyCta: "Naar Eagle Eyes Property",
    forInvestors: "Voor investeerders",
    investmentH: "Investment",
    investmentP: "Een controleerbare, gedisciplineerde aanpak van residentieel vastgoed in Tirana. Voor wie precies wil zien waar hij in investeert.",
    investmentCta: "Naar Eagle Eyes Investment",
  },
  property: {
    kicker: "Eagle Eyes Property",
    h1: "Een thuis in Tirana, vanaf dag één verzorgd.",
    intro: "Wij vinden, bereiden voor en beheren huurappartementen in het centrum van Tirana — voor huurders die een goed geregeld thuis willen, niet zomaar een advertentie.",
    cta: "Schrijf je in voor de wachtlijst",
    navWhat: "Wat we doen",
    navHow: "Hoe het werkt",
    navJoin: "Op de lijst",
    whatTitle: "Wat Eagle Eyes Property doet",
    whatMeta: "Nu aan het onboarden · Listings binnenkort",
    what: [
      { label: "Selectie", title: "Gecureerde appartementen", text: "Elke woning wordt gekozen en geïnspecteerd in de centrale wijken van Tirana — geen eindeloos zoeken door listings die in het echt tegenvallen." },
      { label: "Beheer", title: "Eén aanspreekpunt", text: "Onderhoud, papierwerk en vragen lopen via één team, niet via een lastig bereikbare verhuurder." },
      { label: "Transparantie", title: "Duidelijke voorwaarden, vooraf", text: "Prijzen, contracten en borg helder uitgelegd voordat je tekent — geen verrassingen na je verhuizing." },
    ],
    howTitle: "Hoe het werkt",
    howMeta: "Drie stappen",
    steps: [
      { title: "Vertel ons wat je zoekt", text: "Budget, buurt, grootte, verhuisdatum — de basis die echt verfijnt." },
      { title: "Wij matchen je aan beschikbare woningen", text: "Je hoort van ons zodra we passende appartementen hebben — geen stroom van opties die niet passen." },
      { title: "Verhuis, met ondersteuning daarna", text: "Getekend, gesetteld en verzorgd — Eagle Eyes blijft je aanspreekpunt zolang je bij ons huurt." },
    ],
    waitTitle: "Zie de appartementen als eerste",
    waitText: "Eagle Eyes Property onboardt zijn eerste woningen in het centrum van Tirana. Laat je gegevens achter en we nemen contact op zodra de listings openen.",
    neighbourhood: "Voorkeursbuurt (optioneel)",
    waitButton: "Schrijf je in",
    waitNote: "Geen spam — alleen een bericht zodra appartementen beschikbaar komen.",
    footerBrand: "Eagle Eyes Property",
  },
  investment: {
    kicker: "Eagle Eyes Investment",
    h1: "Residentieel vastgoed in Tirana, gebouwd om te controleren.",
    intro: "Eagle Eyes koopt en verhuurt appartementen in het centrum van Tirana via een gestructureerde Albanese holding — zo ingericht dat elke claim die we maken geverifieerd kan worden, niet op vertrouwen aangenomen.",
    cta: "Vraag het informatiepakket aan",
    navThesis: "Hoe het is opgebouwd",
    navTrack: "Track record",
    navContact: "Contact",
    thesisTitle: "Hoe Eagle Eyes is opgebouwd",
    thesisP1: "Wij kopen appartementen in de centrale wijken van Tirana, verhuren ze aan gescreende huurders via Eagle Eyes Property en houden ze in een toegewijde bedrijfsstructuur — eigendom, beheer en rapportage gescheiden, zodat elk onderdeel onafhankelijk beoordeeld kan worden.",
    thesisP2: "Het doel is een portfolio dat bewust groeit: minder acquisities, elk zo gedocumenteerd dat een investeerder onze redenering kan reconstrueren zonder ons op ons woord te hoeven geloven.",
    specs: [
      { k: "Eigendom", v: "Albanese holding / SPV-structuur" },
      { k: "Operatie", v: "Beheerd via Eagle Eyes Property" },
      { k: "Focus", v: "Appartementen in centrum Tirana" },
      { k: "Rapportage", v: "Documentatie op aanvraag beschikbaar" },
    ],
    trackTitle: "Track record",
    trackMeta: "Eerste acquisities lopend",
    trackBoxTitle: "Resultaten per object — binnenkort",
    trackBoxText: "Zodra appartementen zijn gekocht, verhuurd en (waar van toepassing) verkocht, worden ze hier vermeld met de cijfers erachter — aankoopprijs, uitgevoerde werkzaamheden, bezetting en rendement.",
    trackBoxNote: "Wil je de huidige status vóór publicatie? Vraag het hieronder.",
    verifyTitle: "Wat geverifieerde investeerders kunnen inzien",
    verify: [
      { label: "Entiteit", title: "Bedrijfsstructuur", text: "Registratiedocumenten van de holding en SPV, en hoe het eigendom van elk appartement daaronder valt." },
      { label: "Assets", title: "Details per woning", text: "Locatie, staat, acquisitievoorwaarden en verhuurstatus van elk appartement in bezit of onder bod." },
      { label: "Financiën", title: "Onderliggende cijfers", text: "Kosten, financieringsvoorwaarden en huurinkomsten achter het portfolio — direct gedeeld, niet weggesummariseerd." },
      { label: "Mensen", title: "Wie erachter zit", text: "Achtergrond over wie Eagle Eyes runt en hoe de Property- en Investment-kanten zich tot elkaar verhouden." },
    ],
    contactTitle: "Vraag om de details",
    contactText: "Vertel wie je bent en wat je geverifieerd wilt zien. We reageren direct met de relevante documentatie.",
    roleLabel: "Ik neem contact op als…",
    roles: ["Een potentiële investeerder", "Een bestaande investeerder", "Anders / adviseur"],
    verifyField: "Wat wil je verifiëren? (optioneel)",
    contactButton: "Vraag informatie aan",
    contactNote: "Documentatie wordt direct gedeeld met personen op naam, niet openbaar gepubliceerd.",
    footerBrand: "Eagle Eyes Investment",
  },
  it: {
    kicker: "IT Management",
    h1a: "Eagle Eyes",
    h1b: "IT Management",
    hero: "End-to-end IT-consultancy op maat van uw behoeften — van gerichte oplossingen met een enkele scope en alomvattende strategieën tot langetermijn-portfoliobeheer en doorlopend onderhoud",
    heroCta: "Start een gesprek",
    navProcess: "Hoe wij werken",
    navExpertise: "Expertise",
    navEngagements: "Opdrachten",
    profileTitle: "Profiel",
    profile: "Eagle Eyes IT Management is een management- en consultancypraktijk voor klanten over de hele wereld. Onze consultants zijn direct betrokken van eerste gesprek tot oplevering — endpoint, identity, device management, security en cloud-hosting op Azure en Microsoft 365 — en blijven verantwoordelijk voor het portfolio gedurende de hele contractperiode.",
    processTitle: "Hoe wij werken",
    process: [
      { num: "01", title: "Scope first", text: "Elke opdracht begint met jouw vraag, vervolggesprekken en een geschreven scope: deliverables, acceptatiecriteria, niets vaags." },
      { num: "02", title: "Discovery", text: "Een gedetailleerd onderzoek tegen afgesproken consultancy-uren, vooraf gefactureerd, eindigend in een volledig gecalculeerd voorstel." },
      { num: "03", title: "Contracting", text: "Losse diensten vooraf gefactureerd. Doorlopend werk op maat van jouw organisatie. Portfoliobeheer en onderhoud op jaarcontracten met maandelijkse facturatie. Combinaties zijn bespreekbaar." },
    ],
    expertiseTitle: "Expertise",
    expertise: [
      { title: "Modern workplace", items: "Windows 11 · Intune · Autopilot" },
      { title: "Microsoft 365", items: "Exchange · SharePoint · Teams · Migraties" },
      { title: "Security", items: "Defender · Hardening · Secrets · Patching" },
      { title: "Service management", items: "Jira · JSM · Confluence · Procesontwerp" },
      { title: "Identity & access", items: "Entra ID · Conditional access · MFA · SSO" },
      { title: "Azure & hosting", items: "IaaS / PaaS · Netwerken · Domeinen · SSL" },
      { title: "DevOps & CI/CD", items: "Azure DevOps · Bitbucket · Pipelines" },
      { title: "IT management", items: "Service design · Leveranciers · Budgetten" },
    ],
    engagementsTitle: "Geselecteerde langetermijnopdrachten",
    engagements: [
      { client: "Multinationale leverancier van taalsoftware", role: "IT Business Consultancy & Global DevOps Management", text: "Oprichting van de nieuwste nationale vestiging en ontwerp van de wereldwijde IT-architectuur van de corporatie. Dit engagement omvatte het opschalen van de lokale operatie van 5 naar 60 professionals binnen 18 maanden, terwijl tegelijkertijd de cross-functionele DevOps- en IT-managementteams werden opgebouwd en aangestuurd die de wereldwijde kantoorinfrastructuur dragen." },
      { client: "Wereldwijde autoriteit in software-engineering", role: "IT Cloud & DevOps Consultancy", text: "De bedrijfs-IT-infrastructuur gestructureerd en gestroomlijnd voor een wereldwijd erkende leider in softwareontwikkeling. Dit engagement omvatte het vanaf de grond opbouwen van een hoogwaardig DevOps-ecosysteem en het engineeren van een hybride datacenterinfrastructuur die meer dan 500 interne gebruikers ondersteunt." },
      { client: "Landelijke zakelijke dienstverlener", role: "IT Cloud Consultancy & VoIP-architectuur", text: "Ingebedde, in-house technische consultancy geleverd aan tier-one B2B-klanten en serviceproviders. De kernfocus lag op het ontwerpen en uitrollen van zeer schaalbare VoIP-architecturen en enterprise-grade cloudoplossingen." },
    ],
    contactTitle: "Start een gesprek",
    contactText: "Vertel ons over je omgeving en wat je wilt bereiken. We reageren persoonlijk — meestal binnen één werkdag.",
    companyField: "Bedrijf (optioneel)",
    messageField: "Hoe kunnen we helpen?",
    contactButton: "Verstuur aanvraag",
    contactBlockTitle: "Contact",
    servicesTitle: "Services & Skills",
    productsTitle: "Producten & Merken",
    portfolioTitle: "Portfoliobeheer",
    services: ["Moderne werkplek", "Microsoft 365", "Beveiliging", "Service management", "Identity & access", "Azure & hosting", "DevOps & CI/CD", "IT-management"],
    products: ["Microsoft 365", "Azure", "Entra ID", "Intune", "PowerShell", "Azure DevOps", "Bitbucket", "Postman", "Jira", "Jira Service Management", "Confluence", "Twilio", "Agora"],
    portfolio: ["Service design", "Leveranciersmanagement", "Budgetverantwoording", "Onderhoud & support", "Jaarcontracten", "Maandelijkse facturatie"],
    footerBrand: "Eagle Eyes IT Management",
  },
  digital: {
    kicker: "Eagle Eyes Digital Services",
    h1: "Producten die we bouwen, draaien en laten groeien.",
    intro: "Digital Services is de productstudio van Eagle Eyes: wij ontwerpen, lanceren en beheren onze eigen web- en mobiele producten in social commerce, marketing en boekingen.",
    navPortfolio: "Het portfolio",
    navDeals: "Deals & Marketing",
    navContact: "Contact",
    appsTitle: "Het portfolio",
    live: "Live",
    soon: "Binnenkort",
    capsTitle: "Wat we bouwen",
    caps: [
      { title: "Social commerce", text: "Sociale aandacht omzetten in klanten met shoppable picks en deals." },
      { title: "Campagnes & deals", text: "Tijdsgebonden promoties gemaakt voor delen en snelle conversie." },
      { title: "Boeken & plannen", text: "Afspraken, beschikbaarheid en herinneringen zonder frictie." },
      { title: "Analytics & inzichten", text: "Elk product gemeten van eerste klik tot terugkerende klant." },
    ],
    studioTitle: "Een in-house productstudio",
    studioText: "Digital Services ontwerpt, bouwt en beheert de eigen producten van Eagle Eyes van begin tot eind — van eerste schets tot infrastructuur, support en groei. Geen klantwerk, geen bureaus: eigen producten, eigen standaard.",
    statProducts: "Producten",
    statLive: "Live",
    statLaunching: "In lancering",
    apps: [
      { name: "Socialdeal", tag: "Deals & marketing", status: "live", desc: "Socialdeal geeft lokale bedrijven een snelle manier om tijdsgebonden deals en campagnes te publiceren, gebouwd voor sociaal delen en directe conversie.", url: "https://www.socialdeal.al/", cta: "Bezoek Socialdeal", features: ["Tijdsgebonden deals publiceren", "Gemaakt voor sociaal delen", "Directe conversieflows"] },
      { name: "BookItNow", tag: "Boekingsplatform", status: "soon", desc: "BookItNow is ons nieuwste product: eenvoudig, snel online boeken voor servicebedrijven — afspraken, beschikbaarheid en herinneringen op één plek.", url: "", cta: "Binnenkort", features: ["Online afspraken boeken", "Live beschikbaarheid", "Automatische herinneringen"] },
      { name: "InContact", tag: "SIP & PBX-telefonie", status: "soon", desc: "InContact is ons SIP- & PBX-systeem: cloudtelefonie met zakelijke nummers, belroutes en wachtrijen — online beheerd, zonder hardware op locatie.", url: "", cta: "Binnenkort", features: ["SIP-trunks & hosted PBX", "Belroutes & ringgroepen", "Nummers & voicemail online"] },
    ],
    contactTitle: "Werk met ons",
    contactText: "Interesse in een product, een partnership of een pilot? Laat een bericht achter en we komen bij je terug.",
    messageField: "Je bericht",
    contactButton: "Verstuur bericht",
    footerBrand: "Eagle Eyes Digital Services",
  },
  inc: {
    hero1: "EAGLE",
    hero2: "INC",
    intro: "Eén holding, twee groepen — waar service en ontwikkeling samenkomen.",
    eyesBtn: "Eagle Eyes Group",
    eyesSub: "Real Estate · IT Management · Digital Services",
    eyesCta: "Naar Eagle Eyes Group",
    commerceBtn: "Eagle Commerce Group",
    commerceSub: "Socialdeal · BookItNow · InContact",
    commerceCta: "Naar Eagle Commerce Group",
    footerBrand: "Eagle Inc",
    footerLegal: "Eagle Inc Sh.P.K.",
    tagline: "Holdingmaatschappij",
  },
  commerce: {
    hero1: "EAGLE",
    hero2: "COMMERCE",
    hero3: "GROUP",
    intro: "Eagle Commerce Group ontwerpt, lanceert en beheert zijn eigen e-commerceproducten — van lokale deals tot boekingen en klantcontact.",
    live: "Live",
    soon: "Binnenkort",
    visit: "Bezoek",
    explore: "Ontdek",
    products: [
      { name: "Socialdeal", tag: "Deals & marketing", status: "live", desc: "Lokale deals en marketingcampagnes — snel gepubliceerd, sociaal gedeeld, direct geconverteerd.", url: "https://www.socialdeal.al/", brand: "Eagle Commerce Socialdeal", h1: "Lokale deals, gemaakt om te delen.", story: "Socialdeal geeft lokale ondernemers een snelle, sociale manier om tijdgebonden deals en campagnes te publiceren — gebouwd om gedeeld te worden, afgestemd op directe conversie.", points: ["Tijdgebonden deals publiceren", "Gemaakt voor sociaal delen", "Directe conversieflows"] },
      { name: "BookItNow", tag: "Boekingsplatform", status: "soon", desc: "Eenvoudig en snel online boeken voor dienstverleners — afspraken, beschikbaarheid en herinneringen op één plek.", url: "", brand: "Eagle Commerce BookItNow", h1: "Boeken, zonder frictie.", story: "BookItNow laat dienstverleners binnen enkele minuten online afspraken aannemen — live beschikbaarheid, automatische herinneringen en een boekingsflow die klanten ook echt afronden.", points: ["Online afspraken boeken", "Live beschikbaarheid", "Automatische herinneringen"] },
      { name: "InContact", tag: "SIP & PBX-telefonie", status: "soon", desc: "Cloudtelefonie voor bedrijven: SIP-trunks, hosted PBX en elk nummer op één plek.", url: "", brand: "Eagle Commerce InContact", h1: "Zakelijke telefonie, zonder hardware.", story: "InContact is een volledig SIP- & PBX-platform in de cloud: zakelijke nummers, belroutes, wachtrijen en voicemail — online beheerd, zonder hardware op locatie.", points: ["SIP-trunks & hosted PBX", "Belroutes & wachtrijen", "Nummers online beheerd"] },
    ],
    footerBrand: "Eagle Commerce Group",
  },
};
